import React, { useState, useEffect, useRef } from "react";
import {
  Edit2,
  Wallet,
  Receipt,
  FileText,
  Calendar,
  TrendingUp,
  TrendingDown,
  Users,
  MapPin,
  Trash2,
  PlusCircle,
  Gift,
  ChevronRight,
  ChevronLeft,
  DollarSign,
} from "lucide-react";
import moment from "moment";
import axios from "axios";
import { MyDomain } from "../../../App";
import BossCreateDayWork from "../BossDailyWorkComps/BossCreateDailyWork";
import BossCreateExpenses from "../BossStatisticComps/BossCreateExpenses";
import BossUpdateExpensesModal from "../BossStatisticComps/BossUpdateExpensesModal";
import BossUpdateEmployeeModal from "../BossEmployeeComps/BossUpdateEmployeeModal";
import BossUpdatePlacesModal from "../BossPlacesComps/BossUpdatePlacesModal";
import BossCreateMonthlySalary from "../BossMonthlySalaryComps/BossCreateMonthlySalary";
import BossCreatePlacesGloballyPaidModal from "../BossPlacesComps/BossCreatePlacesGloballyPaidModal";
import BossStatisticPlacesModalAddExtraProfit from "./BossStatisticPlacesModalAddExtraProfit";
import BossCreateInvoice from "../BossInvoicesComps/BossCreateInvoice";
import BossPlaceInvoicesModal from "./BossPlaceInvoicesModal";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../../AppContext";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=JetBrains+Mono:wght@500;700&display=swap');

  .spd2 * { box-sizing: border-box; }
  .spd2 {
    font-family: 'Plus Jakarta Sans', sans-serif;
    background: #F0F2F7;
    color: #111827;
  }

  .spd2-header {
    background: #fff;
    border-bottom: 1px solid #E5E7EB;
    padding: 10px 12px 10px;
    position: sticky; top: 0; z-index: 20;
  }
  .spd2-topbar {
    display: flex; align-items: center; gap: 10px;
  }
  .spd2-back {
    width: 32px; height: 32px; border-radius: 9px;
    border: 1px solid #E5E7EB; background: #F9FAFB;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; color: #374151; transition: all 0.15s; flex-shrink: 0;
  }
  .spd2-back:hover { border-color: #F59E0B; color: #D97706; background: #FFFBEB; }

  .spd2-place-ico {
    width: 36px; height: 36px; border-radius: 10px;
    background: linear-gradient(135deg, #FCD34D, #F59E0B);
    display: flex; align-items: center; justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 2px 8px rgba(245,158,11,0.28);
  }
  .spd2-place-name {
    font-size: 15px; font-weight: 800; color: #111827;
    letter-spacing: -0.02em; line-height: 1.2;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .spd2-place-sub { font-size: 10px; color: #9CA3AF; font-weight: 500; margin-top: 1px; }

  .spd2-hdr-btns { display: flex; align-items: center; gap: 5px; flex-shrink: 0; }
  .spd2-hdr-btn {
    width: 32px; height: 32px; border-radius: 9px; border: none;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: all 0.15s; flex-shrink: 0;
    box-shadow: 0 1px 4px rgba(0,0,0,0.15);
  }
  .spd2-hdr-btn:hover { filter: brightness(1.1); transform: translateY(-1px); box-shadow: 0 3px 8px rgba(0,0,0,0.2); }
  .spd2-hdr-btn:active { transform: translateY(0); filter: brightness(0.9); box-shadow: 0 1px 4px rgba(0,0,0,0.15); }
  .spd2-hdr-btn.edit   { background: #3B82F6; }
  .spd2-hdr-btn.salary { background: #7C3AED; }
  .spd2-hdr-btn.delete { background: #EF4444; }

  .spd2-body { padding: 10px 12px 64px; }

  .spd2-sec-title {
    font-size: 10px; font-weight: 700; color: #6B7280;
    letter-spacing: 0.1em; text-transform: uppercase;
    margin-bottom: 8px;
  }

  .spd2-month-section { margin-bottom: 10px; }
  .spd2-month-row { display: flex; align-items: center; gap: 5px; }
  .spd2-month-arrow {
    width: 28px; height: 28px; border-radius: 7px;
    border: 1px solid #E5E7EB; background: #fff;
    display: flex; align-items: center; justify-content: center;
    cursor: pointer; color: #6B7280; transition: all 0.15s; flex-shrink: 0;
  }
  .spd2-month-arrow:hover { border-color: #F59E0B; color: #D97706; background: #FFFBEB; }
  .spd2-month-scroll-wrap { flex: 1; overflow: hidden; position: relative; }
  .spd2-month-scroll-wrap::before,
  .spd2-month-scroll-wrap::after {
    content: ''; position: absolute; top: 0; bottom: 0; width: 14px; z-index: 2; pointer-events: none;
  }
  .spd2-month-scroll-wrap::before { left:0; background: linear-gradient(to right, #F0F2F7, transparent); }
  .spd2-month-scroll-wrap::after  { right:0; background: linear-gradient(to left,  #F0F2F7, transparent); }
  .spd2-month-track {
    display: flex; gap: 5px; overflow-x: auto; scroll-behavior: smooth;
    padding: 2px 4px; scrollbar-width: none;
  }
  .spd2-month-track::-webkit-scrollbar { display: none; }
  .spd2-month-btn {
    flex-shrink: 0; width: 52px; padding: 5px 3px;
    border-radius: 8px; border: 1.5px solid #E5E7EB;
    background: #fff; cursor: pointer; text-align: center;
    transition: all 0.18s ease;
  }
  .spd2-month-btn:hover { border-color: #FCD34D; background: #FFFBEB; }
  .spd2-month-btn.active {
    background: #F59E0B; border-color: #F59E0B;
    box-shadow: 0 2px 8px rgba(245,158,11,0.3);
    transform: scale(1.05);
  }
  .spd2-month-name { font-size: 12px; font-weight: 700; display: block; color: #374151; line-height: 1.2; }
  .spd2-month-btn.active .spd2-month-name { color: #fff; }
  .spd2-month-year { font-size: 8px; font-weight: 500; color: #9CA3AF; font-family: 'JetBrains Mono', monospace; display: block; margin-top: 1px; }
  .spd2-month-btn.active .spd2-month-year { color: rgba(255,255,255,0.8); }

  .spd2-stats { display: flex; gap: 6px; margin-bottom: 10px; }
  .spd2-stat {
    flex: 1; background: #fff; border-radius: 10px;
    border: 1px solid #E5E7EB; border-left: 3px solid transparent;
    padding: 8px 10px; display: flex; align-items: center; gap: 8px;
  }
  .spd2-stat.blue  { border-left-color: #3B82F6; }
  .spd2-stat.purple{ border-left-color: #7C3AED; }
  .spd2-stat-ico {
    width: 28px; height: 28px; border-radius: 7px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .spd2-stat.blue   .spd2-stat-ico { background: #EFF6FF; }
  .spd2-stat.purple .spd2-stat-ico { background: #EDE9FE; }
  .spd2-stat-val { font-size: 18px; font-weight: 800; color: #111827; letter-spacing: -0.03em; line-height: 1; }
  .spd2-stat-lbl { font-size: 9px; color: #9CA3AF; font-weight: 600; text-transform: uppercase; letter-spacing: 0.05em; margin-top: 2px; }

  .spd2-finance-header {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 8px;
  }
  .spd2-finance-badge {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px; font-weight: 700; color: #D97706;
    background: #FEF3C7; border: 1px solid #FDE68A;
    border-radius: 6px; padding: 2px 7px;
  }

  .spd2-finance-banner {
    background: linear-gradient(135deg, #1e1b4b 0%, #312e81 55%, #1e3a5f 100%);
    border-radius: 13px; padding: 13px 15px; margin-bottom: 10px;
    display: flex; align-items: stretch;
    box-shadow: 0 4px 16px rgba(49,46,129,0.28);
  }
  .spd2-finance-banner-col {
    flex: 1; display: flex; flex-direction: column; gap: 2px;
  }
  .spd2-finance-banner-col + .spd2-finance-banner-col {
    padding-left: 14px; margin-left: 14px;
    border-left: 1px solid rgba(255,255,255,0.12);
    text-align: right;
  }
  .spd2-finance-banner-label {
    font-size: 8px; font-weight: 700; color: rgba(255,255,255,0.5);
    text-transform: uppercase; letter-spacing: 0.1em;
  }
  .spd2-finance-banner-val {
    font-family: 'JetBrains Mono', monospace;
    font-size: 19px; font-weight: 800; letter-spacing: -0.02em; line-height: 1.05;
    color: #fff;
  }
  .spd2-finance-banner-sub {
    font-size: 9px; font-weight: 500; color: rgba(255,255,255,0.4); margin-top: 1px;
  }

  .spd2-fcard {
    background: #fff; border-radius: 11px;
    border: 1px solid #E5E7EB;
    padding: 10px 12px; margin-bottom: 8px;
  }
  .spd2-fcard-row { display: flex; align-items: center; gap: 8px; }
  .spd2-fcard-ico {
    width: 30px; height: 30px; border-radius: 8px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .spd2-fcard-label { flex: 1; font-size: 12px; font-weight: 600; color: #374151; }
  .spd2-fcard-sub { font-size: 9px; color: #9CA3AF; margin-top: 1px; }
  .spd2-fcard-amount { font-family: 'JetBrains Mono', monospace; font-size: 13px; font-weight: 700; }
  .spd2-fcard-divider { height: 1px; background: #F3F4F6; margin: 8px 0; }

  .spd2-list-header {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 6px;
  }
  .spd2-list-lbl { font-size: 9px; font-weight: 700; color: #6B7280; text-transform: uppercase; letter-spacing: 0.07em; }
  .spd2-add-btn {
    display: flex; align-items: center; gap: 4px;
    background: #F0FDF4; border: 1px solid #86EFAC;
    color: #059669; font-size: 10px; font-weight: 700;
    padding: 3px 8px; border-radius: 6px; cursor: pointer;
    transition: all 0.15s; font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .spd2-add-btn:hover { background: #DCFCE7; border-color: #059669; }

  .spd2-list-item { display: flex; align-items: center; gap: 6px; margin-bottom: 5px; }
  .spd2-list-item-inner {
    flex: 1; display: flex; align-items: center; justify-content: space-between;
    background: #F9FAFB; border: 1px solid #E5E7EB;
    border-radius: 8px; padding: 6px 8px; min-width: 0;
  }
  .spd2-list-item-left { display: flex; align-items: center; gap: 6px; min-width: 0; }
  .spd2-list-item-ico {
    width: 22px; height: 22px; border-radius: 6px;
    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
  }
  .spd2-list-item-title { font-size: 11px; font-weight: 600; color: #374151; }
  .spd2-list-item-sub { font-size: 9px; color: #9CA3AF; margin-top: 1px; }
  .spd2-list-item-amt { font-family: 'JetBrains Mono', monospace; font-size: 11px; font-weight: 700; flex-shrink: 0; }
  .spd2-del-btn {
    width: 26px; height: 26px; border-radius: 6px; border: none;
    background: #FEE2E2; display: flex; align-items: center; justify-content: center;
    cursor: pointer; transition: background 0.15s; flex-shrink: 0;
  }
  .spd2-del-btn:hover { background: #FECACA; }

  .spd2-empty-list {
    display: flex; flex-direction: column; align-items: center;
    padding: 12px 12px; gap: 4px; text-align: center;
  }
  .spd2-empty-list p { font-size: 11px; color: #9CA3AF; font-weight: 500; }

  .spd2-exp-type-row {
    display: flex; align-items: center; justify-content: space-between;
    padding: 5px 0; border-bottom: 1px solid #F9FAFB;
  }
  .spd2-exp-type-row:last-child { border-bottom: none; }
  .spd2-exp-type-left { display: flex; align-items: center; gap: 6px; }
  .spd2-exp-type-ico { width: 22px; height: 22px; border-radius: 6px; display: flex; align-items: center; justify-content: center; }
  .spd2-exp-badge { font-size: 8px; font-weight: 700; background: #F3F4F6; color: #6B7280; border-radius: 4px; padding: 1px 4px; }

  .spd2-pair {
    display: grid; grid-template-columns: 1fr; gap: 8px; margin-bottom: 8px;
  }
  .spd2-pair > .spd2-fcard { margin-bottom: 0; }
  @media (min-width: 768px) { .spd2-pair { grid-template-columns: 1fr 1fr; align-items: start; } }

  .spd2-costs-row {
    display: grid; grid-template-columns: 1fr; gap: 8px; margin-bottom: 8px;
  }
  .spd2-costs-row > * { margin-bottom: 0; }
  @media (min-width: 768px) { .spd2-costs-row { grid-template-columns: repeat(3, 1fr); align-items: start; } }

  .spd2-net-card {
    border-radius: 11px; padding: 12px;
    border: 2px solid transparent; margin-bottom: 8px;
  }
  .spd2-net-card.positive { background: #F0FDF4; border-color: #86EFAC; }
  .spd2-net-card.negative { background: #FFF1F2; border-color: #FECACA; }

  .spd2-days-header {
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 8px;
  }
  .spd2-days-badge {
    font-family: 'JetBrains Mono', monospace;
    font-size: 9px; font-weight: 600; color: #D97706;
    background: #FEF3C7; border: 1px solid #FDE68A;
    border-radius: 5px; padding: 2px 6px;
  }

  .spd2-day-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px; }
  @media (min-width: 480px) { .spd2-day-grid { grid-template-columns: repeat(4, 1fr); } }
  @media (min-width: 768px) { .spd2-day-grid { grid-template-columns: repeat(5, 1fr); } }

  .spd2-day {
    background: #fff; border: 1.5px solid #E5E7EB;
    border-radius: 10px; padding: 8px; min-height: 90px;
    cursor: pointer; position: relative; transition: all 0.18s ease;
    display: flex; flex-direction: column; text-align: left;
  }
  .spd2-day:hover { box-shadow: 0 3px 12px rgba(0,0,0,0.08); transform: translateY(-1px); }
  .spd2-day.worked { border-color: #FCD34D; background: #FFFBEB; }
  .spd2-day.today  { box-shadow: 0 0 0 2px rgba(59,130,246,0.2); border-color: #93C5FD; }
  .spd2-day.worked.today { border-color: #F59E0B; }

  .spd2-day-top {
    display: flex; justify-content: space-between; align-items: flex-start;
    margin-bottom: 5px; padding-bottom: 5px; border-bottom: 1px solid #F3F4F6;
  }
  .spd2-day.worked .spd2-day-top { border-bottom-color: #FDE68A; }
  .spd2-day-num { font-size: 15px; font-weight: 800; color: #D1D5DB; line-height: 1; }
  .spd2-day.worked .spd2-day-num { color: #D97706; }
  .spd2-day.today  .spd2-day-num { color: #3B82F6; }
  .spd2-day-name { font-size: 7px; font-weight: 700; color: #9CA3AF; text-transform: uppercase; letter-spacing: 0.06em; }
  .spd2-day.worked .spd2-day-name { color: #92400E; }

  .spd2-day-body { flex: 1; display: flex; flex-direction: column; gap: 3px; }

  .spd2-day-badges { display: flex; gap: 3px; flex-wrap: wrap; margin-bottom: 3px; }
  .spd2-badge { display: inline-flex; align-items: center; gap: 2px; font-size: 8px; font-weight: 700; padding: 2px 4px; border-radius: 4px; }
  .spd2-badge.emp    { background: #EDE9FE; color: #7C3AED; }
  .spd2-badge.salary { background: #FEE2E2; color: #DC2626; }
  .spd2-badge.rev    { background: #D1FAE5; color: #059669; }

  .spd2-day-emp {
    background: #fff; border: 1px solid #F3F4F6;
    border-radius: 6px; padding: 4px 5px;
    display: flex; align-items: flex-start; gap: 4px;
  }
  .spd2-day.worked .spd2-day-emp { background: #FFFBEB; border-color: #FDE68A; }
  .spd2-day-emp-name { font-size: 8px; font-weight: 600; color: #374151; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .spd2-day-emp-sal  { font-size: 8px; font-weight: 700; color: #DC2626; }
  .spd2-day-emp-rev  { font-size: 8px; font-weight: 700; color: #059669; }
  .spd2-day-emp-mgr  { font-size: 7px; color: #9CA3AF; font-style: italic; }

  .spd2-day-empty {
    flex: 1; display: flex; flex-direction: column;
    align-items: center; justify-content: center; gap: 2px;
  }
  .spd2-day-note-dot {
    position: absolute; top: 5px; right: 5px;
    width: 12px; height: 12px; border-radius: 3px;
    background: #FEF9C3; border: 1px solid #FDE68A;
    display: flex; align-items: center; justify-content: center;
  }

  .spd2-loading {
    display: flex; align-items: center; justify-content: center;
    height: 200px; background: #F0F2F7;
  }
  .spd2-spinner {
    width: 32px; height: 32px;
    border: 3px solid #E5E7EB; border-top-color: #F59E0B;
    border-radius: 50%; animation: spd2-spin 0.75s linear infinite;
  }
  @keyframes spd2-spin { to { transform: rotate(360deg); } }
`;

export default function BossStatisticPlaces2({ onBack }) {
  const { t } = useTranslation();
  const { setAllData: setContextAllData } = useAppContext();
  const monthTrackRef = useRef(null);

  const [choosedPlace, setChoosedPlace] = useState(null);
  const [choosedMonth, setChoosedMonth] = useState(null);
  const [allData, setAllData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  const [showCreateModal, setShowCreateModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState("");
  const [existingEmployees, setExistingEmployees] = useState([]);
  const [showCreateExpenseModal, setShowCreateExpenseModal] = useState(false);
  const [showUpdateExpenseModal, setShowUpdateExpenseModal] = useState(false);
  const [selectedExpense, setSelectedExpense] = useState(null);
  const [showUpdateEmployeeModal, setShowUpdateEmployeeModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [showUpdatePlaceModal, setShowUpdatePlaceModal] = useState(false);
  const [showMonthlySalaryModal, setShowMonthlySalaryModal] = useState(false);
  const [showGlobalPaymentModal, setShowGlobalPaymentModal] = useState(false);
  const [showExtraProfitModal, setShowExtraProfitModal] = useState(false);
  const [createInvoiceVisible, setCreateInvoiceVisible] = useState(false);
  const [showPlaceInvoicesModal, setShowPlaceInvoicesModal] = useState(false);
  const [placeInvoices, setPlaceInvoices] = useState([]);
  const [confirmDialog, setConfirmDialog] = useState({
    visible: false,
    message: "",
    onConfirm: null,
  });
  const [toast, setToast] = useState({
    visible: false,
    message: "",
    type: "success",
  });

  useEffect(() => {
    const place = localStorage.getItem("choosedPlace");
    const month =
      localStorage.getItem("choosedMonth") || moment().format("MM-YYYY");
    const data = localStorage.getItem("allData");
    const user = localStorage.getItem("user");
    if (place) setChoosedPlace(JSON.parse(place));
    if (data) setAllData(JSON.parse(data));
    if (user) setUserData(JSON.parse(user));
    setChoosedMonth(month);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (choosedMonth) localStorage.setItem("choosedMonth", choosedMonth);
  }, [choosedMonth]);

  useEffect(() => {
    if (!choosedMonth || !monthTrackRef.current) return;
    const idx = monthList.findIndex((m) => m === choosedMonth);
    if (idx < 0) return;
    const btn = monthTrackRef.current.children[idx];
    if (btn)
      btn.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
  }, [choosedMonth]);

  useEffect(() => {
    if (!loading && choosedPlace?.id && userData?.id) loadPlaceInvoices();
  }, [loading, choosedPlace?.id, userData?.id]);

  const getExchangeRate = async (currency) => {
    try {
      if (currency === "ILS") return 1;
      const res = await fetch(`https://open.er-api.com/v6/latest/${currency}`);
      if (res.ok) {
        const d = await res.json();
        if (d?.rates?.ILS && d.rates.ILS > 0) return d.rates.ILS;
      }
      const res2 = await fetch(
        `https://api.exchangerate.host/convert?from=${currency}&to=ILS&amount=1`,
      );
      if (res2.ok) {
        const d2 = await res2.json();
        if (d2?.result && d2.result > 0) return d2.result;
      }
      return null;
    } catch {
      return null;
    }
  };

  const loadPlaceInvoices = async () => {
    if (!userData?.id || !choosedPlace?.id) return;
    try {
      const API = MyDomain.endsWith("/") ? MyDomain.slice(0, -1) : MyDomain;
      const res = await fetch(`${API}/api/email-invoices/${userData.id}`);
      if (res.ok) {
        const d = await res.json();
        const linked = (d.invoices || []).filter(
          (i) => Number(i.placeId) === Number(choosedPlace.id),
        );
        const enriched = await Promise.all(
          linked.map(async (inv) => {
            const currency = inv.currency || "ILS";
            if (currency === "ILS")
              return {
                ...inv,
                ilsEquivalent: parseFloat(inv.price || 0),
                exchangeRate: 1,
              };
            const rate = await getExchangeRate(currency);
            const ilsEquivalent =
              rate != null ? parseFloat(inv.price || 0) * rate : null;
            return { ...inv, ilsEquivalent, exchangeRate: rate };
          }),
        );
        setPlaceInvoices(enriched);
      }
    } catch {}
  };

  const fetchAllData = async () => {
    if (!userData) return;
    try {
      const response = await axios.post(`${MyDomain}Employee/GetAllData`, {
        UserId: userData.id,
      });
      const data = response.data || {};
      setAllData(data);
      localStorage.setItem("allData", JSON.stringify(data));
      setContextAllData(data);
      if (choosedPlace?.id && data?.myPlaces) {
        const updated = data.myPlaces.find((p) => p.id === choosedPlace.id);
        if (updated) {
          setChoosedPlace(updated);
          localStorage.setItem("choosedPlace", JSON.stringify(updated));
        }
      }
    } catch (err) {
      console.error(err);
    }
  };

  if (loading || !choosedPlace || !allData) {
    return (
      <div className="spd2">
        <style>{STYLES}</style>
        <div className="spd2-loading">
          <div className="spd2-spinner" />
        </div>
      </div>
    );
  }

  const generateMonths = () => {
    const months = [];
    const now = new Date();
    for (let i = 0; i < 12; i++) {
      const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      months.push(
        `${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`,
      );
    }
    return months;
  };
  const monthList = generateMonths();

  const scrollMonths = (dir) => {
    if (monthTrackRef.current)
      monthTrackRef.current.scrollBy({ left: dir * 180, behavior: "smooth" });
  };

  const expenseTypes = [
    { id: 1, name: t("materials"), color: "#3B82F6" },
    { id: 2, name: t("equipment"), color: "#8B5CF6" },
    { id: 3, name: t("transportation"), color: "#10B981" },
    { id: 4, name: t("utilities"), color: "#F59E0B" },
    { id: 5, name: t("otherExpense"), color: "#6B7280" },
  ];

  const filteredDailyWork = (allData.myDailyWork || []).filter((item) => {
    if (!choosedPlace?.id || !choosedMonth) return false;
    const [, month, year] = item.date.split("-");
    return (
      item.placeId === choosedPlace.id && `${month}-${year}` === choosedMonth
    );
  });
  const filteredExpenses = (allData.myExpenses || []).filter((item) => {
    if (item.placeId !== choosedPlace.id || !item.date?.trim()) return false;
    const parts = item.date.split("-");
    if (parts.length !== 3) return false;
    return `${parts[1]}-${parts[2]}` === choosedMonth;
  });
  const filteredMonthlySalaries = (
    Array.isArray(allData?.myMonthlySalary) ? allData.myMonthlySalary : []
  ).filter((item) => {
    if (item.placeId !== choosedPlace.id || !item.date?.trim()) return false;
    const p = item.date.split("-");
    if (p.length !== 3) return false;
    return `${p[1]}-${p[2]}` === choosedMonth;
  });
  const filteredExtraProfits = (
    Array.isArray(allData?.myPlaceExtraProfit) ? allData.myPlaceExtraProfit : []
  ).filter((item) => {
    if (item.placeId !== choosedPlace.id || !item.date?.trim()) return false;
    const p = item.date.split("-");
    if (p.length !== 3) return false;
    return `${p[1]}-${p[2]}` === choosedMonth;
  });

  const allTimeDailyWork = (allData.myDailyWork || []).filter(
    (i) => i.placeId === choosedPlace?.id,
  );
  const allTimeExpenses = (allData.myExpenses || []).filter(
    (i) => Number(i.placeId) === Number(choosedPlace.id) && i.date?.trim(),
  );
  const allTimeMonthlySalaries = (
    Array.isArray(allData?.myMonthlySalary) ? allData.myMonthlySalary : []
  ).filter(
    (i) => Number(i.placeId) === Number(choosedPlace.id) && i.date?.trim(),
  );

  const totalExpensesAmount = filteredExpenses.reduce(
    (s, e) => s + (parseFloat(e.price) || 0),
    0,
  );
  const totalDailySalaries = filteredDailyWork.reduce(
    (s, i) => s + (parseFloat(i.salary) || 0),
    0,
  );
  const totalMonthlySalaries = filteredMonthlySalaries.reduce((s, item) => {
    const emp = (allData.myEmployees || []).find(
      (e) => e.id === item.employeeId,
    );
    return s + (emp?.monthlySalary || 0);
  }, 0);
  const totalExtraProfit = filteredExtraProfits.reduce(
    (s, i) => s + (parseFloat(i.profit) || 0),
    0,
  );
  const totalSalaries = totalDailySalaries + totalMonthlySalaries;

  const allTimeExpensesAmount = allTimeExpenses.reduce(
    (s, e) => s + (parseFloat(e.price) || 0),
    0,
  );
  const allTimeDailySal = allTimeDailyWork.reduce(
    (s, i) => s + (parseFloat(i.salary) || 0),
    0,
  );
  const allTimeMonthlySal = allTimeMonthlySalaries.reduce((s, item) => {
    const emp = (allData.myEmployees || []).find(
      (e) => e.id === item.employeeId,
    );
    return s + (emp?.monthlySalary || 0);
  }, 0);
  const allTimeTotalSalaries = allTimeDailySal + allTimeMonthlySal;

  const globalPayments = (
    Array.isArray(allData?.myPlacesGloballyPaid)
      ? allData.myPlacesGloballyPaid
      : []
  ).filter((p) => p.placeId === choosedPlace?.id);
  const totalGlobalPaymentsReceived = globalPayments.reduce(
    (s, p) => s + (parseFloat(p.profit) || 0),
    0,
  );
  const totalGlobalProfit = parseFloat(choosedPlace?.profit || 0);

  // Filter linked invoices to the selected month (same logic as BossStatisticByDate)
  const placeMonthInvoices = placeInvoices.filter((inv) => {
    if (!inv.date) return false;
    const sep = inv.date.includes("/") ? "/" : "-";
    const parts = inv.date.split(sep);
    if (parts.length !== 3) return false;
    const mm = parts[1].padStart(2, "0");
    const yyyy = parts[2];
    return `${mm}-${yyyy}` === choosedMonth;
  });

  const totalInvoicesCost = placeMonthInvoices.reduce((s, inv) => {
    const ils =
      inv.ilsEquivalent != null
        ? inv.ilsEquivalent
        : parseFloat(inv.price || 0);
    return s + ils;
  }, 0);

  let placeRevenue = 0,
    netProfit = 0;
  if (choosedPlace?.paidWay === 2) {
    placeRevenue = filteredDailyWork.reduce(
      (s, i) => s + (parseFloat(i.placeDailySalary) || 0),
      0,
    );
    netProfit =
      placeRevenue -
      totalSalaries -
      totalExpensesAmount -
      totalInvoicesCost +
      totalExtraProfit;
  } else if (choosedPlace?.paidWay === 3) {
    placeRevenue = totalGlobalPaymentsReceived;
    netProfit =
      totalGlobalPaymentsReceived -
      allTimeTotalSalaries -
      allTimeExpensesAmount -
      totalInvoicesCost +
      totalExtraProfit;
  } else {
    placeRevenue = parseFloat(choosedPlace?.profit || 0);
    netProfit =
      placeRevenue -
      totalSalaries -
      totalExpensesAmount -
      totalInvoicesCost +
      totalExtraProfit;
  }

  const getAllDaysInMonth = () => {
    if (!choosedMonth) return [];
    const [month, year] = choosedMonth.split("-");
    const days = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();
    return Array.from(
      { length: days },
      (_, i) => `${String(i + 1).padStart(2, "0")}-${month}-${year}`,
    );
  };
  const groupByDate = () =>
    filteredDailyWork.reduce((g, item) => {
      if (!g[item.date]) g[item.date] = [];
      g[item.date].push(item);
      return g;
    }, {});
  const allDays = getAllDaysInMonth();
  const groupedData = groupByDate();

  const getDayTotal = (date) =>
    (groupedData[date] || []).reduce(
      (s, i) => s + (parseFloat(i.salary) || 0),
      0,
    );
  const getDayRevenue = (date) =>
    (groupedData[date] || []).reduce(
      (s, i) => s + (parseFloat(i.placeDailySalary) || 0),
      0,
    );
  const hasNotes = (date) =>
    (groupedData[date] || []).some((i) => i.note?.trim());

  const workingDays = Object.keys(groupedData).length;
  const uniqueEmployees = new Set(filteredDailyWork.map((i) => i.employeeId))
    .size;

  const getEmployeeName = (id) =>
    (allData.myEmployees || []).find((e) => e.id === id)?.name ||
    `Employee ${id}`;
  const getManagerName = (id) =>
    (allData.myEmployees || []).find((e) => e.id === id)?.name || "Me";

  const handleDayClick = (date) => {
    const dayData = groupedData[date] || [];
    setSelectedDate(date);
    setExistingEmployees(
      dayData.map((item) => {
        const emp = (allData.myEmployees || []).find(
          (e) => e.id === item.employeeId,
        );
        return {
          id: item.employeeId,
          name: emp?.name || `Employee ${item.employeeId}`,
          salary: item.salary.toString(),
        };
      }),
    );
    setShowCreateModal(true);
  };

  const showConfirm = (message) =>
    new Promise((resolve) =>
      setConfirmDialog({ visible: true, message, onConfirm: resolve }),
    );
  const showToast = (message, type = "success") => {
    setToast({ visible: true, message, type });
    setTimeout(
      () => setToast({ visible: false, message: "", type: "success" }),
      3000,
    );
  };

  const handleDeleteExpense = async (expense) => {
    const confirmed = await showConfirm(`Delete expense "${expense.title}"?`);
    if (!confirmed) return;
    try {
      await axios.delete(`${MyDomain}Expenses/DeleteExpense`, {
        data: { Id: expense.id },
      });
      fetchAllData();
    } catch {
      showToast("Failed to delete expense", "error");
    }
  };
  const handleDeleteMonthlySalary = async (ms, empName) => {
    const confirmed = await showConfirm(
      `Delete monthly salary for ${empName}?`,
    );
    if (!confirmed) return;
    try {
      await axios.delete(`${MyDomain}MonthlySalary/DeleteMonthlySalary`, {
        data: { Id: ms.id },
      });
      fetchAllData();
    } catch {
      showToast("Failed to delete monthly salary", "error");
    }
  };
  const handleDeleteGlobalPayment = async (payment) => {
    const amt = `₪${parseFloat(payment.profit).toLocaleString()}`;
    const dt = moment(payment.dateGetPaid, "DD-MM-YYYY").format("MMM DD, YYYY");
    const confirmed = await showConfirm(`Delete payment ${amt} from ${dt}?`);
    if (!confirmed) return;
    try {
      await axios.delete(
        `${MyDomain}PlacesGloballyPaid/DeletePlacesGloballyPaid`,
        { data: { Id: payment.id } },
      );
      fetchAllData();
    } catch {
      showToast("Failed to delete payment", "error");
    }
  };
  const handleDeleteExtraProfit = async (ep) => {
    const amt = `₪${parseFloat(ep.profit).toLocaleString()}`;
    const dt = moment(ep.date, "DD-MM-YYYY").format("MMM DD, YYYY");
    const confirmed = await showConfirm(
      `Delete extra profit ${amt} from ${dt}?`,
    );
    if (!confirmed) return;
    try {
      await axios.delete(`${MyDomain}PlaceExtraProfit/DeletePlaceExtraProfit`, {
        data: { Id: ep.id },
      });
      fetchAllData();
    } catch {
      showToast("Failed to delete extra profit", "error");
    }
  };

  const handleDeletePlace = async () => {
    const confirmed = await showConfirm(
      `Delete place "${choosedPlace?.place}"? This will also delete all daily work records for this place.`,
    );
    if (!confirmed) return;
    try {
      await axios.delete(`${MyDomain}Places/DeletePlace`, {
        data: { Id: choosedPlace.id, UserId: userData.id },
      });
      localStorage.removeItem("choosedPlace");
      await fetchAllData();
      onBack();
    } catch {
      showToast("Failed to delete place", "error");
    }
  };

  const showFinancialBreakdown =
    choosedPlace?.paidWay === 2 ||
    placeRevenue > 0 ||
    choosedPlace?.paidWay === 3 ||
    placeMonthInvoices.length > 0 ||
    totalExpensesAmount > 0 ||
    totalSalaries > 0;
  const totalCosts =
    choosedPlace?.paidWay === 3
      ? allTimeTotalSalaries + allTimeExpensesAmount + totalInvoicesCost
      : totalSalaries + totalExpensesAmount + totalInvoicesCost;

  const paidWayLabel = {
    1: t("monthlyProfitLabel"),
    2: t("totalRevenue"),
    3: t("globalProfitLabel"),
  };
  const currencySymbol = { ILS: "₪", USD: "$", EUR: "€", GBP: "£" };

  const expTypeData = expenseTypes
    .map((t) => ({
      ...t,
      value: filteredExpenses
        .filter((e) => e.type === t.id)
        .reduce((s, e) => s + (parseFloat(e.price) || 0), 0),
    }))
    .filter((t) => t.value > 0);

  return (
    <div className="spd2" style={{ paddingTop: 20 }}>
      <style>{STYLES}</style>

      <header className="spd2-header">
        <div className="spd2-topbar">
          <div className="spd2-place-ico">
            <MapPin size={17} color="#fff" />
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <p className="spd2-place-name">{choosedPlace?.place}</p>
            <p className="spd2-place-sub">{t("placePerformance")}</p>
          </div>
          <div className="spd2-hdr-btns">
            <button
              className="spd2-hdr-btn edit"
              title={t("edit")}
              onClick={() => setShowUpdatePlaceModal(true)}
            >
              <Edit2 size={14} color="#fff" />
            </button>
            <button
              className="spd2-hdr-btn salary"
              title={t("salary")}
              onClick={() => setShowMonthlySalaryModal(true)}
            >
              <Wallet size={14} color="#fff" />
            </button>
            <button
              className="spd2-hdr-btn delete"
              title={t("delete")}
              onClick={handleDeletePlace}
            >
              <Trash2 size={14} color="#fff" />
            </button>
          </div>
        </div>
      </header>

      <div className="spd2-body">
        {/* Month scroller */}
        <div className="spd2-month-section">
          <p className="spd2-sec-title">{t("selectMonth")}</p>
          <div className="spd2-month-row">
            <button
              className="spd2-month-arrow"
              onClick={() => scrollMonths(-1)}
            >
              <ChevronLeft size={14} />
            </button>
            <div className="spd2-month-scroll-wrap">
              <div className="spd2-month-track" ref={monthTrackRef}>
                {monthList.map((item) => {
                  const [, year] = item.split("-");
                  return (
                    <button
                      key={item}
                      className={`spd2-month-btn${choosedMonth === item ? " active" : ""}`}
                      onClick={() => setChoosedMonth(item)}
                    >
                      <span className="spd2-month-name">
                        {moment(item, "MM-YYYY").format("MMM")}
                      </span>
                      <span className="spd2-month-year">{year}</span>
                    </button>
                  );
                })}
              </div>
            </div>
            <button
              className="spd2-month-arrow"
              onClick={() => scrollMonths(1)}
            >
              <ChevronRight size={14} />
            </button>
          </div>
        </div>

        {/* Quick stats */}
        <div className="spd2-stats">
          <div className="spd2-stat blue">
            <div className="spd2-stat-ico">
              <Calendar size={14} color="#3B82F6" />
            </div>
            <div>
              <div className="spd2-stat-val">{workingDays}</div>
              <div className="spd2-stat-lbl">{t("workingDays")}</div>
            </div>
          </div>
          <div className="spd2-stat purple">
            <div className="spd2-stat-ico">
              <Users size={14} color="#7C3AED" />
            </div>
            <div>
              <div className="spd2-stat-val">{uniqueEmployees}</div>
              <div className="spd2-stat-lbl">{t("employees")}</div>
            </div>
          </div>
        </div>

        {/* Financial Breakdown */}
        {showFinancialBreakdown && (
          <div style={{ marginBottom: 12 }}>
            <div className="spd2-finance-header">
              <p className="spd2-sec-title" style={{ marginBottom: 0 }}>
                {t("financialBreakdown")}
              </p>
              <span className="spd2-finance-badge">
                ₪{totalCosts.toLocaleString()} {t("costs")}
              </span>
            </div>

            {/* <div className="spd2-finance-banner">
              <div className="spd2-finance-banner-col">
                <span className="spd2-finance-banner-label">
                  {paidWayLabel[choosedPlace?.paidWay] || "Revenue"}
                </span>
                <span className="spd2-finance-banner-val">
                  ₪{placeRevenue.toLocaleString()}
                </span>
                {totalExtraProfit > 0 && (
                  <span className="spd2-finance-banner-sub">
                    +₪{totalExtraProfit.toLocaleString()} extra
                  </span>
                )}
              </div>
              <div className="spd2-finance-banner-col">
                <span className="spd2-finance-banner-label">
                  {t("netProfit")}
                </span>
                <span
                  className="spd2-finance-banner-val"
                  style={{ color: netProfit >= 0 ? "#4ADE80" : "#F87171" }}
                >
                  ₪{netProfit.toLocaleString()}
                </span>
                <span className="spd2-finance-banner-sub">
                  {netProfit >= 0 ? "profitable" : "running at loss"} · ₪
                  {totalCosts.toLocaleString()} costs
                </span>
              </div>
            </div> */}

            <div className="spd2-pair">
              {(placeRevenue > 0 || choosedPlace?.paidWay === 3) && (
                <div className="spd2-fcard">
                  <div className="spd2-fcard-row">
                    <div
                      className="spd2-fcard-ico"
                      style={{ background: "#D1FAE5" }}
                    >
                      <TrendingUp size={16} color="#059669" />
                    </div>
                    <div style={{ flex: 1 }}>
                      <p className="spd2-fcard-label">
                        {paidWayLabel[choosedPlace?.paidWay] || t("profitLabel")}
                      </p>
                      <p className="spd2-fcard-sub">
                        {choosedPlace?.paidWay === 2
                          ? t("dailyRevenueCollected")
                          : choosedPlace?.paidWay === 3
                            ? t("receivedFromGlobalProfit")
                            : t("monthlyPlaceProfit")}
                      </p>
                    </div>
                    <span
                      className="spd2-fcard-amount"
                      style={{ color: "#059669" }}
                    >
                      {choosedPlace?.paidWay === 3
                        ? `₪${totalGlobalPaymentsReceived.toLocaleString()} / ₪${totalGlobalProfit.toLocaleString()}`
                        : `₪${placeRevenue.toLocaleString()}`}
                    </span>
                  </div>

                  {choosedPlace?.paidWay === 3 && (
                    <>
                      <div className="spd2-fcard-divider" />
                      <div className="spd2-list-header">
                        <span className="spd2-list-lbl">
                          {t("paymentsReceived")}
                        </span>
                        <button
                          className="spd2-add-btn"
                          onClick={() => setShowGlobalPaymentModal(true)}
                        >
                          <PlusCircle size={11} /> {t("addPayment")}
                        </button>
                      </div>
                      {globalPayments.length === 0 ? (
                        <div className="spd2-empty-list">
                          <Wallet size={20} color="#D1D5DB" />
                          <p>{t("noData")}</p>
                        </div>
                      ) : (
                        globalPayments.map((payment) => (
                          <div key={payment.id} className="spd2-list-item">
                            <div className="spd2-list-item-inner">
                              <div className="spd2-list-item-left">
                                <div
                                  className="spd2-list-item-ico"
                                  style={{ background: "#D1FAE5" }}
                                >
                                  <DollarSign size={12} color="#059669" />
                                </div>
                                <div>
                                  <p className="spd2-list-item-title">
                                    {moment(
                                      payment.dateGetPaid,
                                      "DD-MM-YYYY",
                                    ).format("MMM DD, YYYY")}
                                  </p>
                                </div>
                              </div>
                              <span
                                className="spd2-list-item-amt"
                                style={{ color: "#059669" }}
                              >
                                ₪{parseFloat(payment.profit).toLocaleString()}
                              </span>
                            </div>
                            <button
                              className="spd2-del-btn"
                              onClick={() => handleDeleteGlobalPayment(payment)}
                            >
                              <Trash2 size={13} color="#EF4444" />
                            </button>
                          </div>
                        ))
                      )}
                    </>
                  )}
                </div>
              )}

              <div className="spd2-fcard">
                <div className="spd2-fcard-row">
                  <div
                    className="spd2-fcard-ico"
                    style={{ background: "#D1FAE5" }}
                  >
                    <Gift size={16} color="#059669" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="spd2-fcard-label">{t("extraProfit")}</p>
                    <p className="spd2-fcard-sub">{t("additionalWorkIncome")}</p>
                  </div>
                  <span
                    className="spd2-fcard-amount"
                    style={{ color: "#059669" }}
                  >
                    ₪{totalExtraProfit.toLocaleString()}
                  </span>
                </div>
                <div className="spd2-fcard-divider" />
                <div className="spd2-list-header">
                  <span className="spd2-list-lbl">{t("extraProfit")}</span>
                  <button
                    className="spd2-add-btn"
                    onClick={() => setShowExtraProfitModal(true)}
                  >
                    <PlusCircle size={11} /> {t("addExtra")}
                  </button>
                </div>
                {filteredExtraProfits.length === 0 ? (
                  <div className="spd2-empty-list">
                    <Gift size={20} color="#D1D5DB" />
                    <p>{t("noData")}</p>
                  </div>
                ) : (
                  filteredExtraProfits.map((ep) => (
                    <div key={ep.id} className="spd2-list-item">
                      <div className="spd2-list-item-inner">
                        <div className="spd2-list-item-left">
                          <div
                            className="spd2-list-item-ico"
                            style={{ background: "#D1FAE5" }}
                          >
                            <Gift size={12} color="#059669" />
                          </div>
                          <div>
                            <p className="spd2-list-item-title">
                              {moment(ep.date, "DD-MM-YYYY").format(
                                "MMM DD, YYYY",
                              )}
                            </p>
                            {ep.note?.trim() && (
                              <p
                                className="spd2-list-item-sub"
                                style={{ fontStyle: "italic" }}
                              >
                                {ep.note}
                              </p>
                            )}
                          </div>
                        </div>
                        <span
                          className="spd2-list-item-amt"
                          style={{ color: "#059669" }}
                        >
                          ₪{parseFloat(ep.profit).toLocaleString()}
                        </span>
                      </div>
                      <button
                        className="spd2-del-btn"
                        onClick={() => handleDeleteExtraProfit(ep)}
                      >
                        <Trash2 size={13} color="#EF4444" />
                      </button>
                    </div>
                  ))
                )}
              </div>
            </div>

            {totalMonthlySalaries > 0 && (
              <div className="spd2-fcard" style={{ marginBottom: 8 }}>
                <div className="spd2-fcard-row">
                  <div
                    className="spd2-fcard-ico"
                    style={{ background: "#EDE9FE" }}
                  >
                    <Wallet size={16} color="#7C3AED" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="spd2-fcard-label">{t("monthlyEmployees")}</p>
                    <p className="spd2-fcard-sub">{t("fixedMonthlySalaries")}</p>
                  </div>
                  <span
                    className="spd2-fcard-amount"
                    style={{ color: "#7C3AED" }}
                  >
                    ₪{totalMonthlySalaries.toLocaleString()}
                  </span>
                </div>
                <div className="spd2-fcard-divider" />
                {filteredMonthlySalaries.map((item) => {
                  const emp = (allData.myEmployees || []).find(
                    (e) => e.id === item.employeeId,
                  );
                  if (!emp) return null;
                  return (
                    <div key={item.id} className="spd2-list-item">
                      <div className="spd2-list-item-inner">
                        <div className="spd2-list-item-left">
                          <div
                            className="spd2-list-item-ico"
                            style={{ background: "#EDE9FE" }}
                          >
                            <Users size={12} color="#7C3AED" />
                          </div>
                          <div>
                            <p className="spd2-list-item-title">{emp.name}</p>
                            <p className="spd2-list-item-sub">
                              {t("paid")}:{" "}
                              {moment(item.date, "DD-MM-YYYY").format("MMM DD")}
                            </p>
                          </div>
                        </div>
                        <span
                          className="spd2-list-item-amt"
                          style={{ color: "#7C3AED" }}
                        >
                          ₪{emp.monthlySalary?.toLocaleString() || 0}
                        </span>
                      </div>
                      <button
                        className="spd2-del-btn"
                        onClick={() =>
                          handleDeleteMonthlySalary(item, emp.name)
                        }
                      >
                        <Trash2 size={13} color="#EF4444" />
                      </button>
                    </div>
                  );
                })}
              </div>
            )}

            <div className="spd2-pair">
              <div className="spd2-fcard">
                <div className="spd2-fcard-row">
                  <div
                    className="spd2-fcard-ico"
                    style={{ background: "#FEF3C7" }}
                  >
                    <Receipt size={16} color="#D97706" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="spd2-fcard-label">{t("totalExpenses")}</p>
                    <p className="spd2-fcard-sub">
                      {filteredExpenses.length} {t("items")} {t("thisMonth")}
                    </p>
                  </div>
                  <span
                    className="spd2-fcard-amount"
                    style={{ color: "#D97706" }}
                  >
                    ₪{totalExpensesAmount.toLocaleString()}
                  </span>
                </div>
                <div className="spd2-fcard-divider" />
                <div className="spd2-list-header">
                  <span className="spd2-list-lbl">{t("expenses")}</span>
                  <button
                    className="spd2-add-btn"
                    onClick={() => setShowCreateExpenseModal(true)}
                  >
                    <PlusCircle size={11} /> {t("expense")}
                  </button>
                </div>
                {filteredExpenses.length === 0 ? (
                  <div className="spd2-empty-list">
                    <Receipt size={20} color="#D1D5DB" />
                    <p>{t("noData")}</p>
                  </div>
                ) : (
                  expenseTypes.map((type) => {
                    const typeExp = filteredExpenses.filter(
                      (e) => e.type === type.id,
                    );
                    const typeTotal = typeExp.reduce(
                      (s, e) => s + (parseFloat(e.price) || 0),
                      0,
                    );
                    if (typeTotal === 0) return null;
                    return (
                      <div
                        key={type.id}
                        style={{ borderBottom: "1px solid #F9FAFB" }}
                      >
                        <div
                          className="spd2-exp-type-row"
                          style={{ borderBottom: "none" }}
                        >
                          <div className="spd2-exp-type-left">
                            <div
                              className="spd2-exp-type-ico"
                              style={{ background: type.color + "20" }}
                            >
                              <Receipt size={12} color={type.color} />
                            </div>
                            <span
                              style={{
                                fontSize: 12,
                                fontWeight: 600,
                                color: "#374151",
                              }}
                            >
                              {type.name}
                            </span>
                            <span className="spd2-exp-badge">
                              {typeExp.length}
                            </span>
                          </div>
                          <span
                            style={{
                              fontSize: 13,
                              fontWeight: 700,
                              color: type.color,
                              fontFamily: "'JetBrains Mono',monospace",
                            }}
                          >
                            ₪{typeTotal.toLocaleString()}
                          </span>
                        </div>
                        {typeExp.map((expense) => (
                          <div
                            key={expense.id}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              padding: "5px 4px 5px 34px",
                              gap: 8,
                            }}
                          >
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <span
                                style={{
                                  fontSize: 11,
                                  fontWeight: 600,
                                  color: "#374151",
                                }}
                              >
                                {expense.title ||
                                  moment(expense.date, "DD-MM-YYYY").format(
                                    "MMM DD",
                                  )}
                              </span>
                              {expense.note?.trim() && (
                                <p
                                  style={{
                                    fontSize: 10,
                                    color: "#9CA3AF",
                                    margin: "2px 0 0",
                                    fontStyle: "italic",
                                    lineHeight: 1.3,
                                  }}
                                >
                                  {expense.note}
                                </p>
                              )}
                            </div>
                            <span
                              style={{
                                fontSize: 11,
                                fontWeight: 700,
                                color: type.color,
                                fontFamily: "'JetBrains Mono',monospace",
                                flexShrink: 0,
                              }}
                            >
                              ₪{parseFloat(expense.price).toLocaleString()}
                            </span>
                            <button
                              className="spd2-del-btn"
                              style={{ background: "#DBEAFE", flexShrink: 0 }}
                              onClick={() => {
                                setSelectedExpense(expense);
                                setShowUpdateExpenseModal(true);
                              }}
                            >
                              <Edit2 size={13} color="#3B82F6" />
                            </button>
                            <button
                              className="spd2-del-btn"
                              onClick={() => handleDeleteExpense(expense)}
                            >
                              <Trash2 size={13} color="#EF4444" />
                            </button>
                          </div>
                        ))}
                      </div>
                    );
                  })
                )}
              </div>

              <div className="spd2-fcard">
                <div className="spd2-fcard-row">
                  <div
                    className="spd2-fcard-ico"
                    style={{ background: "#EDE9FE" }}
                  >
                    <FileText size={16} color="#7C3AED" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="spd2-fcard-label">{t("invoiceCosts")}</p>
                    <p className="spd2-fcard-sub">
                      {placeMonthInvoices.length > 0
                        ? `${placeMonthInvoices.length} ${t("invoices").toLowerCase()}`
                        : t("noInvoicesLinkedYet")}
                    </p>
                  </div>
                  {totalInvoicesCost > 0 && (
                    <span
                      className="spd2-fcard-amount"
                      style={{ color: "#7C3AED" }}
                    >
                      ₪
                      {totalInvoicesCost.toLocaleString("he-IL", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </span>
                  )}
                </div>
                <div className="spd2-fcard-divider" />
                {placeMonthInvoices.length === 0 ? (
                  <div className="spd2-empty-list">
                    <FileText size={20} color="#D1D5DB" />
                    <p>{t("noInvoicesFound")}</p>
                  </div>
                ) : (
                  <>
                    {placeMonthInvoices.map((inv) => {
                      const currency = inv.currency || "ILS";
                      const sym = currencySymbol[currency] || currency;
                      const faceValue = parseFloat(inv.price || 0);
                      const ilsVal = inv.ilsEquivalent;
                      const isForeign = currency !== "ILS";
                      const rateAvailable = inv.exchangeRate != null;
                      return (
                        <div
                          key={inv.id}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-start",
                            fontSize: 11,
                            color: "#6b7280",
                            padding: "8px 0",
                            borderBottom: "1px solid #f9fafb",
                            gap: 8,
                          }}
                        >
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div
                              style={{
                                fontWeight: 600,
                                color: "#374151",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {inv.subject ||
                                inv.whoSend ||
                                inv.description ||
                                "Invoice"}
                            </div>
                            {inv.date && (
                              <div
                                style={{
                                  fontSize: 10,
                                  color: "#9ca3af",
                                  marginTop: 1,
                                }}
                              >
                                {inv.date}
                              </div>
                            )}
                            {isForeign && (
                              <div
                                style={{
                                  fontSize: 9,
                                  color: "#7c3aed",
                                  marginTop: 2,
                                  fontStyle: "italic",
                                }}
                              >
                                {rateAvailable
                                  ? `1 ${currency} = ₪${inv.exchangeRate.toFixed(3)}`
                                  : t("rateUnavailable")}
                              </div>
                            )}
                          </div>
                          <div style={{ textAlign: "right", flexShrink: 0 }}>
                            <div
                              style={{
                                fontWeight: 700,
                                color: "#7c3aed",
                                fontFamily: "monospace",
                              }}
                            >
                              {sym}
                              {faceValue.toLocaleString("he-IL", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                              {isForeign && (
                                <span
                                  style={{
                                    fontSize: 9,
                                    marginLeft: 3,
                                    color: "#9ca3af",
                                  }}
                                >
                                  {currency}
                                </span>
                              )}
                            </div>
                            {isForeign && ilsVal != null && (
                              <div
                                style={{
                                  fontSize: 10,
                                  color: "#6d28d9",
                                  fontFamily: "monospace",
                                  marginTop: 2,
                                }}
                              >
                                ≈ ₪
                                {ilsVal.toLocaleString("he-IL", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </div>
                            )}
                            {isForeign && ilsVal == null && (
                              <div
                                style={{
                                  fontSize: 9,
                                  color: "#f59e0b",
                                  marginTop: 2,
                                }}
                              >
                                ({t("rateLookupFailed")})
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: 8,
                        paddingTop: 8,
                        borderTop: "1.5px solid #ede9fe",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 11,
                          fontWeight: 700,
                          color: "#6d28d9",
                        }}
                      >
                        {t("totalIlsEquivalent")}
                      </span>
                      <span
                        style={{
                          fontSize: 13,
                          fontWeight: 800,
                          color: "#7c3aed",
                          fontFamily: "monospace",
                        }}
                      >
                        ₪
                        {totalInvoicesCost.toLocaleString("he-IL", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  </>
                )}
                <div style={{ display: "flex", gap: 6, marginTop: 10 }}>
                  <button
                    onClick={() => setCreateInvoiceVisible(true)}
                    style={{
                      flex: 1,
                      padding: "8px",
                      background: "#f5f3ff",
                      border: "1px solid #c4b5fd",
                      borderRadius: 8,
                      color: "#7c3aed",
                      fontSize: 12,
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    + {t("newInvoice")}
                  </button>
                  <button
                    onClick={() => setShowPlaceInvoicesModal(true)}
                    style={{
                      flex: 1,
                      padding: "8px",
                      background: "#ede9fe",
                      border: "none",
                      borderRadius: 8,
                      color: "#7c3aed",
                      fontSize: 12,
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    {placeInvoices.length > 0
                      ? `${t("manageInvoices")} →`
                      : `+ ${t("linkInvoices")}`}
                  </button>
                </div>
              </div>
            </div>

            <div
              className={totalDailySalaries > 0 ? "spd2-pair" : undefined}
              style={{ marginBottom: 8 }}
            >
              {totalDailySalaries > 0 && (
                <div className="spd2-fcard" style={{ marginBottom: 0 }}>
                  <div className="spd2-fcard-row">
                    <div
                      className="spd2-fcard-ico"
                      style={{ background: "#FEE2E2" }}
                    >
                      <Calendar size={16} color="#DC2626" />
                    </div>
                    <div style={{ flex: 1 }}>
                      <p className="spd2-fcard-label">{t("dailySalaries")}</p>
                      <p className="spd2-fcard-sub">{t("paidToDailyEmployees")}</p>
                    </div>
                    <span
                      className="spd2-fcard-amount"
                      style={{ color: "#DC2626" }}
                    >
                      ₪{totalDailySalaries.toLocaleString()}
                    </span>
                  </div>
                </div>
              )}
              <div
                className={`spd2-net-card ${netProfit >= 0 ? "positive" : "negative"}`}
                style={{ marginBottom: 0 }}
              >
                <div className="spd2-fcard-row">
                  <div
                    className="spd2-fcard-ico"
                    style={{
                      background: netProfit >= 0 ? "#D1FAE5" : "#FEE2E2",
                    }}
                  >
                    {netProfit >= 0 ? (
                      <TrendingUp size={16} color="#059669" />
                    ) : (
                      <TrendingDown size={16} color="#DC2626" />
                    )}
                  </div>
                  <div style={{ flex: 1 }}>
                    <p className="spd2-fcard-label">{t("netProfit")}</p>
                    <p className="spd2-fcard-sub">
                      {choosedPlace?.paidWay === 2
                        ? t("revenueMinusCosts")
                        : choosedPlace?.paidWay === 3
                          ? t("receivedMinusAllCosts")
                          : t("profitMinusCosts")}
                    </p>
                  </div>
                  <span
                    style={{
                      fontFamily: "'JetBrains Mono',monospace",
                      fontSize: 17,
                      fontWeight: 800,
                      color: netProfit >= 0 ? "#059669" : "#DC2626",
                    }}
                  >
                    ₪{netProfit.toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Analytics Charts */}
        {(showFinancialBreakdown || filteredDailyWork.length > 0) &&
          (() => {
            const expByDate = filteredExpenses.reduce((acc, e) => {
              acc[e.date] = (acc[e.date] || 0) + (parseFloat(e.price) || 0);
              return acc;
            }, {});
            const extraByDate = filteredExtraProfits.reduce((acc, ep) => {
              acc[ep.date] = (acc[ep.date] || 0) + (parseFloat(ep.profit) || 0);
              return acc;
            }, {});
            const invByDate = placeMonthInvoices.reduce((acc, inv) => {
              if (!inv.date) return acc;
              const sep = inv.date.includes("/") ? "/" : "-";
              const p = inv.date.split(sep);
              if (p.length !== 3) return acc;
              const key = `${p[0].padStart(2, "0")}-${p[1].padStart(2, "0")}-${p[2]}`;
              const ils =
                inv.ilsEquivalent != null
                  ? inv.ilsEquivalent
                  : parseFloat(inv.price || 0);
              acc[key] = (acc[key] || 0) + ils;
              return acc;
            }, {});

            const globalByDate =
              choosedPlace?.paidWay === 3
                ? globalPayments
                    .filter((p) => {
                      if (!p.dateGetPaid?.trim()) return false;
                      const pts = p.dateGetPaid.split("-");
                      return (
                        pts.length === 3 &&
                        `${pts[1]}-${pts[2]}` === choosedMonth
                      );
                    })
                    .reduce((acc, p) => {
                      acc[p.dateGetPaid] =
                        (acc[p.dateGetPaid] || 0) + (parseFloat(p.profit) || 0);
                      return acc;
                    }, {})
                : {};

            const showRevenue = choosedPlace?.paidWay === 2;

            const activeDays = allDays.filter(
              (d) =>
                getDayTotal(d) > 0 ||
                getDayRevenue(d) > 0 ||
                (globalByDate[d] || 0) > 0 ||
                (expByDate[d] || 0) > 0 ||
                (extraByDate[d] || 0) > 0 ||
                (invByDate[d] || 0) > 0,
            );

            if (activeDays.length === 0) return null;

            const salaryData = activeDays.map((d) => getDayTotal(d));
            const revenueData = activeDays.map((d) => getDayRevenue(d));
            const globalData = activeDays.map((d) => globalByDate[d] || 0);
            const expenseData = activeDays.map((d) => expByDate[d] || 0);
            const extraData = activeDays.map((d) => extraByDate[d] || 0);
            const invoiceData = activeDays.map((d) => invByDate[d] || 0);

            const hasSalary = salaryData.some((v) => v > 0);
            const hasRevenue = showRevenue && revenueData.some((v) => v > 0);
            const hasGlobal =
              choosedPlace?.paidWay === 3 && globalData.some((v) => v > 0);
            const hasExpenses = expenseData.some((v) => v > 0);
            const hasExtra = extraData.some((v) => v > 0);
            const hasInvoices = invoiceData.some((v) => v > 0);

            const datasets = [
              ...(hasRevenue
                ? [
                    {
                      label: t("revenueLabel"),
                      data: revenueData,
                      backgroundColor: "rgba(5,150,105,0.65)",
                      borderColor: "#059669",
                      borderWidth: 1,
                      borderRadius: 2,
                      stack: "income",
                    },
                  ]
                : []),
              ...(hasGlobal
                ? [
                    {
                      label: t("globalProfitLabel"),
                      data: globalData,
                      backgroundColor: "rgba(5,150,105,0.65)",
                      borderColor: "#059669",
                      borderWidth: 1,
                      borderRadius: 2,
                      stack: "income",
                    },
                  ]
                : []),
              ...(hasExtra
                ? [
                    {
                      label: `${t("extraProfit")} +`,
                      data: extraData,
                      backgroundColor: "rgba(13,148,136,0.65)",
                      borderColor: "#0D9488",
                      borderWidth: 1,
                      borderRadius: 2,
                      stack: "income",
                    },
                  ]
                : []),
              ...(hasSalary
                ? [
                    {
                      label: t("salary"),
                      data: salaryData,
                      backgroundColor: "rgba(220,38,38,0.6)",
                      borderColor: "#DC2626",
                      borderWidth: 1,
                      borderRadius: 2,
                      stack: "costs",
                    },
                  ]
                : []),
              ...(hasExpenses
                ? [
                    {
                      label: t("expenses"),
                      data: expenseData,
                      backgroundColor: "rgba(217,119,6,0.6)",
                      borderColor: "#D97706",
                      borderWidth: 1,
                      borderRadius: 2,
                      stack: "costs",
                    },
                  ]
                : []),
              ...(hasInvoices
                ? [
                    {
                      label: t("invoices"),
                      data: invoiceData,
                      backgroundColor: "rgba(124,58,237,0.6)",
                      borderColor: "#7C3AED",
                      borderWidth: 1,
                      borderRadius: 2,
                      stack: "costs",
                    },
                  ]
                : []),
            ];

            return (
              <div style={{ marginBottom: 12 }}>
                <p className="spd2-sec-title">{t("analytics")}</p>
                <div className="spd2-fcard" style={{ marginBottom: 8 }}>
                  <p className="spd2-sec-title" style={{ marginBottom: 6 }}>
                    {t("dailyBreakdown")}
                  </p>
                  <div style={{ overflowX: "auto", overflowY: "hidden" }}>
                    <div
                      style={{
                        minWidth: Math.max(activeDays.length * 16, 280),
                        height: 300,
                      }}
                    >
                      <Bar
                        data={{
                          labels: activeDays.map((d) =>
                            moment(d, "DD-MM-YYYY").format("D"),
                          ),
                          datasets,
                        }}
                        options={{
                          responsive: true,
                          maintainAspectRatio: false,
                          plugins: {
                            legend: {
                              display: true,
                              position: "bottom",
                              labels: {
                                boxWidth: 8,
                                font: { size: 9 },
                                padding: 6,
                              },
                            },
                            tooltip: {
                              filter: (item) => item.parsed.y > 0,
                              callbacks: {
                                label: (ctx) =>
                                  ` ${ctx.dataset.label}: ₪${ctx.parsed.y.toLocaleString()}`,
                              },
                            },
                          },
                          scales: {
                            x: {
                              stacked: true,
                              grid: { display: false },
                              ticks: { font: { size: 8 }, color: "#9CA3AF" },
                            },
                            y: {
                              stacked: true,
                              grid: { color: "#F9FAFB" },
                              ticks: {
                                font: { size: 8 },
                                color: "#9CA3AF",
                                maxTicksLimit: 4,
                                callback: (v) =>
                                  v >= 1000
                                    ? `₪${(v / 1000).toFixed(0)}k`
                                    : `₪${v}`,
                              },
                            },
                          },
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            );
          })()}

        {/* Daily Operations */}
        <div>
          <div className="spd2-days-header">
            <p className="spd2-sec-title" style={{ marginBottom: 0 }}>
              {t("dailyOperations")}
            </p>
            <span className="spd2-days-badge">{allDays.length} {t("days")}</span>
          </div>

          {allDays.length === 0 ? (
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                padding: "32px 20px",
                textAlign: "center",
                border: "1px solid #E5E7EB",
              }}
            >
              <Calendar
                size={32}
                color="#D1D5DB"
                style={{ margin: "0 auto 10px" }}
              />
              <p style={{ fontSize: 14, fontWeight: 600, color: "#9CA3AF" }}>
                {t("noDataThisMonth")}
              </p>
            </div>
          ) : (
            <div className="spd2-day-grid">
              {allDays.map((date) => {
                const dayData = groupedData[date] || [];
                const hasWork = dayData.length > 0;
                const hasNote = hasNotes(date);
                const isToday = moment(date, "DD-MM-YYYY").isSame(
                  moment(),
                  "day",
                );
                const dayNum = moment(date, "DD-MM-YYYY").format("DD");
                const dayName = moment(date, "DD-MM-YYYY").format("ddd");
                return (
                  <button
                    key={date}
                    className={`spd2-day${hasWork ? " worked" : ""}${isToday ? " today" : ""}`}
                    onClick={() => handleDayClick(date)}
                  >
                    {hasNote && (
                      <div className="spd2-day-note-dot">
                        <FileText size={8} color="#D97706" />
                      </div>
                    )}
                    <div className="spd2-day-top">
                      <span className="spd2-day-num">{dayNum}</span>
                      <span className="spd2-day-name">{dayName}</span>
                    </div>
                    <div className="spd2-day-body">
                      {hasWork ? (
                        <>
                          <div className="spd2-day-badges">
                            <span className="spd2-badge emp">
                              <Users size={8} /> {dayData.length}
                            </span>
                            {choosedPlace?.paidWay === 2 ? (
                              <span className="spd2-badge rev">
                                <TrendingUp size={8} />₪
                                {getDayRevenue(date).toFixed(0)}
                              </span>
                            ) : (
                              <span className="spd2-badge salary">
                                <DollarSign size={8} />₪
                                {getDayTotal(date).toFixed(0)}
                              </span>
                            )}
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 3,
                            }}
                          >
                            {dayData.map((item) => (
                              <div key={item.id} className="spd2-day-emp">
                                <div style={{ flex: 1, minWidth: 0 }}>
                                  <p className="spd2-day-emp-name">
                                    {getEmployeeName(item.employeeId)}
                                  </p>
                                  <p className="spd2-day-emp-sal">
                                    ₪{item.salary}
                                  </p>
                                  {choosedPlace?.paidWay === 2 &&
                                    item.placeDailySalary && (
                                      <p className="spd2-day-emp-rev">
                                        Rev: ₪{item.placeDailySalary}
                                      </p>
                                    )}
                                  {item.whoMake && (
                                    <p className="spd2-day-emp-mgr">
                                      by {getManagerName(item.whoMake)}
                                    </p>
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        </>
                      ) : (
                        <div className="spd2-day-empty">
                          <PlusCircle size={20} color="#D1D5DB" />
                          <span
                            style={{
                              fontSize: 9,
                              color: "#9CA3AF",
                              fontWeight: 600,
                            }}
                          >
                            {t("noActivity")}
                          </span>
                          <span style={{ fontSize: 8, color: "#D1D5DB" }}>
                            {t("tapToAdd")}
                          </span>
                        </div>
                      )}
                    </div>
                  </button>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <BossCreateDayWork
        visible={showCreateModal}
        onClose={() => {
          setShowCreateModal(false);
          setExistingEmployees([]);
        }}
        onSuccess={() => {
          setShowCreateModal(false);
          setExistingEmployees([]);
          fetchAllData();
        }}
        places={allData.myPlaces}
        employees={allData.myEmployees}
        preselectedDate={selectedDate}
        preselectedPlaceId={choosedPlace?.id}
        preselectedEmployees={existingEmployees}
      />
      <BossCreateExpenses
        visible={showCreateExpenseModal}
        onClose={() => setShowCreateExpenseModal(false)}
        onSuccess={() => {
          setShowCreateExpenseModal(false);
          fetchAllData();
        }}
        preselectedPlaceId={choosedPlace?.id}
      />
      <BossUpdateExpensesModal
        visible={showUpdateExpenseModal}
        onClose={() => setShowUpdateExpenseModal(false)}
        expense={selectedExpense}
        onUpdateSuccess={() => {
          setShowUpdateExpenseModal(false);
          fetchAllData();
        }}
      />
      <BossUpdateEmployeeModal
        visible={showUpdateEmployeeModal}
        onClose={() => setShowUpdateEmployeeModal(false)}
        employee={selectedEmployee}
        onUpdateSuccess={() => {
          setShowUpdateEmployeeModal(false);
          fetchAllData();
        }}
      />
      <BossUpdatePlacesModal
        visible={showUpdatePlaceModal}
        onClose={() => setShowUpdatePlaceModal(false)}
        place={choosedPlace}
        onUpdateSuccess={async () => {
          setShowUpdatePlaceModal(false);
          await fetchAllData();
        }}
      />
      <BossCreateMonthlySalary
        visible={showMonthlySalaryModal}
        onClose={() => setShowMonthlySalaryModal(false)}
        onSuccess={() => {
          setShowMonthlySalaryModal(false);
          fetchAllData();
        }}
        placeId={choosedPlace?.id}
        placeName={choosedPlace?.place}
      />
      <BossCreatePlacesGloballyPaidModal
        visible={showGlobalPaymentModal}
        onClose={() => setShowGlobalPaymentModal(false)}
        onSuccess={() => {
          setShowGlobalPaymentModal(false);
          fetchAllData();
        }}
        placeId={choosedPlace?.id}
        placeName={choosedPlace?.place}
      />
      <BossStatisticPlacesModalAddExtraProfit
        visible={showExtraProfitModal}
        onClose={() => setShowExtraProfitModal(false)}
        onSuccess={() => {
          setShowExtraProfitModal(false);
          fetchAllData();
        }}
        placeId={choosedPlace?.id}
        placeName={choosedPlace?.place}
      />
      <BossCreateInvoice
        visible={createInvoiceVisible}
        onClose={() => setCreateInvoiceVisible(false)}
        onSuccess={() => {
          setCreateInvoiceVisible(false);
          fetchAllData();
          loadPlaceInvoices();
        }}
        preselectedPlaceId={choosedPlace?.id}
      />
      <BossPlaceInvoicesModal
        visible={showPlaceInvoicesModal}
        onClose={() => setShowPlaceInvoicesModal(false)}
        placeId={choosedPlace?.id}
        placeName={choosedPlace?.place}
        onInvoicesChange={() => {
          loadPlaceInvoices();
          fetchAllData();
        }}
      />

      {confirmDialog.visible && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-6">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm shadow-2xl">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                <Trash2 className="w-5 h-5 text-red-600" />
              </div>
              <p className="text-gray-800 font-medium leading-snug">
                {confirmDialog.message}
              </p>
            </div>
            <div className="flex gap-3">
              <button
                className="flex-1 py-2.5 rounded-xl border border-gray-200 text-gray-700 font-semibold text-sm"
                onClick={() => {
                  confirmDialog.onConfirm(false);
                  setConfirmDialog({
                    visible: false,
                    message: "",
                    onConfirm: null,
                  });
                }}
              >
                {t("cancel")}
              </button>
              <button
                className="flex-1 py-2.5 rounded-xl bg-red-600 text-white font-semibold text-sm"
                onClick={() => {
                  confirmDialog.onConfirm(true);
                  setConfirmDialog({
                    visible: false,
                    message: "",
                    onConfirm: null,
                  });
                }}
              >
                {t("delete")}
              </button>
            </div>
          </div>
        </div>
      )}

      {toast.visible && (
        <div
          className={`fixed bottom-6 left-1/2 -translate-x-1/2 z-50 px-5 py-3 rounded-xl shadow-lg text-white text-sm font-semibold ${toast.type === "error" ? "bg-red-600" : "bg-green-600"}`}
        >
          {toast.message}
        </div>
      )}
    </div>
  );
}
